import React, { useContext } from 'react';
import UserContext from '../context/userContext';
import { hasMenuPermission } from '../../utils/permissions';

/**
 * ProtectedRoute component that checks user permissions before rendering the route
 * Redirects to unauthorized page if user lacks required permissions
 * 
 * @param {string} permission - The permission key required to access this route
 * @param {Function} render - The render function for the route
 * @param {Object} props - Route props passed by React Router
 */
const ProtectedRoute = ({ permission, render, ...props }) => {
  const context = useContext(UserContext);

  // Wait for permissions to be loaded before checking
  // permissions array should exist and fullEmpresa.modules should be loaded
  const isContextLoaded = context.permissions !== undefined && 
                         context.fullEmpresa !== undefined &&
                         context.fullEmpresa.modules !== undefined;

  // Show loading state while context is being populated
  if (!isContextLoaded) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        A carregar...
      </div>
    );
  }

  // If no permission is specified, render the component
  if (!permission) {
    return render(props);
  }

  // Check if user has the required permission
  const hasAccess = hasMenuPermission(permission, context);

  // If user doesn't have permission, redirect to unauthorized page
  if (!hasAccess) {
    window.location.href = 'https://eposgestofinal.com/index.php?page=unauthorized';
    return null;
  }

  // User has permission, render the component
  return render(props);
};

export default ProtectedRoute;

